<template>
    <div
        class="empty-state-container"
        :style="{ paddingTop: verticalPadding, paddingBottom: verticalPadding }"
    >
        <div v-if="$slots.text" class="empty-state-text">
            <Text size="f-8" align="center">
                <slot name="text" />
            </Text>
        </div>
        <Spacer v-if="$slots.button" />
        <slot v-if="$slots.button" name="button" />
    </div>
</template>

<script setup lang="ts">
import { Text, Spacer } from '@opteo/components-next'

type Props = {
    verticalPadding?: string
}

const props = withDefaults(defineProps<Props>(), {
    verticalPadding: '4.875rem',
})
</script>

<style lang="scss" scoped>
@import '@/assets/css/theme.scss';
@import '@/assets/css/variables.scss';

.empty-state-container {
    @include flex-center;
    flex-direction: column;
    @include ph-24;
}
.empty-state-text {
    max-width: 330px;
}
</style>
